import React from 'react';
import Applications from 'screens/applications/Applications';
import UserRoute from 'components/Routes/UserRoute';

const routes = [
  <UserRoute key="applications" path="/Applications"><Applications/></UserRoute>
];

export default routes;
